import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/utils";

const mapVariant = (variant) => {
    switch (variant) {
        case "destructive":
            return "va-button--destructive";
        case "outline":
            return "va-button--outline";
        case "secondary":
            return "va-button--secondary";
        case "ghost":
            return "va-button--ghost";
        case "link":
            return "va-button--link";
        default:
            return "";
    }
};

const mapSize = (size) => {
    switch (size) {
        case "sm":
            return "va-button--sm";
        case "lg":
            return "va-button--lg";
        case "icon":
            return "va-button--icon";
        default:
            return "";
    }
};

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (<Comp className={cn("va-button", mapVariant(variant), mapSize(size), className)} ref={ref} {...props}/>);
});
Button.displayName = "Button";
export { Button };
